import { render, staticRenderFns } from "./rule-view.vue?vue&type=template&id=6892577c&scoped=true"
import script from "./rule-view.vue?vue&type=script&lang=js"
export * from "./rule-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6892577c",
  null
  
)

export default component.exports